import { defineComponent } from 'vue';
import axios, { AxiosResponse } from 'axios';
import DCApp from "./../Shared/App.vue";
import * as Vue from 'vue';
import { createPinia } from 'pinia';
export class Trademark {

}

export class Contact {
    public RegistryId: string = "";
    public Name: string = "";
    public Organization: string = "";
    public Address: string[] = [];
    public TelephoneNumber: string = "";
    public TelephoneNumberExt: string = "";
    public FaxNumber: string = "";
    public FaxNumberExt: string = "";
    public Email: string = "";
    public Created: Date | null = null;
    public Updated: Date | null = null;
}

export class Registrar {
    public  Name: string = "";
    public  IanaId: string = "";
    public  Url: string = "";
    public  AbuseEmail: string = "";
    public  AbuseTelephoneNumber: string = "";
    public WhoisServer!: HostName;
}


export class HostName {
    public IsPunyCode: boolean = false;
    public IsTld: boolean = false;
    public Tld: string = "";
    public Value: string = "";
}

export enum WhoisStatus {
    Unknown = 0,
    Found = 1,
    NotFound = 2,
    Error = 3,
    Throttled = 4,
    Expired = 5,
    PendingDelete = 6,
    Reserved = 7,
    Suspended = 8,
    NotAssigned = 9,
    Invalid = 10,
    Inactive = 11,
    Locked = 12,
    Quarantined = 13,
    OutOfService = 14,
    NotAvailable = 15,
    Deactivated = 16,
    Failed = 17,
    Unconfirmed = 18,
    Unavailable = 19,
    ToBeReleased = 20,
    Redemption = 21,
    Blocked = 22,
    Other = 23
}

export class WhoisResponse {

    public TemplateName: string = "";
    public  ParsingErrors: number = 0;
    public  FieldsParsed: number = 0;
    public Trademark!: Trademark;
        public  DnsSecStatus: string = "";
        public  Remarks: string = "";
    public NameServers: string[] = [];
    public ZoneContact!: Contact;
    public  BillingContact!: Contact;
    public  AdminContact!: Contact;
    public Referrer!: WhoisResponse;
        public  TechnicalContact!: Contact;
    public Registrar!: Registrar;
    public Expiration: Date | null = null;
    public  Updated: Date | null = null;
    public  Registered: Date | null = null;
        public DomainStatus: string[] = [];
        public  RegistryDomainId: string = "";
    public DomainName!: HostName;
    public Status!: WhoisStatus;
        public  ContentLength: number = 0;
        public  Content: string = "";
        public  Registrant!: Contact;
    public  WhoisServer!: HostName;
    }

export class WhoisApiViewModel {
    public m_whoisresponse!: WhoisResponse;
    }

export class WhoisApiRequest {
    public dns: string = "";
    public whoisserver: string = "";
    public followreferrer: boolean = true;
}



const mixin = defineComponent({
    data() {
        return {
            view: null as WhoisApiViewModel | null,
            dns: "",
            whoisserver: "",
            followreferrer: true
        };
    },

    mounted() {

    },
    methods: {
        Reinit() {
            this.dns = "";
            this.whoisserver = "";
            this.followreferrer = true;
            this.view = null;
        },
        JoinString(elts: string[]): string {
            if (elts == null)
                return "";
            return elts.join('-');
        },
        CopyClipboard(text: string) {
            navigator.clipboard.writeText(text);
        },

        Whois() {
            let request: WhoisApiRequest = new WhoisApiRequest();
            request.dns = this.dns;
            request.whoisserver = this.whoisserver;
            request.followreferrer = this.followreferrer;
            this.RequestWhois(request);
        },

        RequestWhois(request: WhoisApiRequest) {
            let self = this;
            axios.post<WhoisApiViewModel>("/api/v1/Whois/RequestWhois", request).then(function (response: AxiosResponse<WhoisApiViewModel>) {
                if (response.data !== null) {
                    self.view = response.data;
                    // alert(JSON.stringify(self.view?.m_whoisresponse.TechnicalContact.Email));
                }
            });
        }
    }
});


export class WhoisComponent {
    public Init() {
        DCApp.mixins = [mixin];
        const app = Vue.createApp(DCApp);
        const pinia = createPinia();
        app.use(pinia);
        app.mount('#rootpage');
    }
}
(<any>(window)).WhoisComponent = function () { return new WhoisComponent(); };